/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Thai (Thailand)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'พิมพ์อะไรบางอย่าง...',
  'fabric.editor.editorAssistiveLabel': 'พื้นที่เนื้อหาหลัก เริ่มพิมพ์เพื่อป้อนข้อความ',
  'fabric.editor.headingLink.toolbarHelpTitle': 'เปิดกรอบโต้ตอบความช่วยเหลือ'
};